module.exports = __webpack_public_path__ + "static/mhotspot--laptop-wifi-router-76bc5be23bd5a0297e1e9ad93fdf60ad.jpg";